// All credit and mortgage rates
// If you need to change or supplement the data - check the render on the pages after the update.

/**
 * core/models/common/MainSliderSlides/HomePage/HomePageSlidesModel.js
 * core/models/common/OfferSliderSlides/ForIndividuals/CreditSlidesModel.js
 * core/models/pages/for-individuals/RefinancingModel.js
 * components/Pages/ForIndividuals/TeacherCard/TeacherCardAdvantages.vue
 * core/models/pages/for-individuals/PotrebRefinancingModel.js
 * core/plugins/getMetaParamsForPage.js
 * core/models/pages/for-individuals/crediting/DynamicCreditingModel.js
*/
export const potrebCredit = {
    rate: '22,5',
    maxRate: '23,25',
    ratesOnAmount: [
        '24,75', // до 300_000
        '24,25', // от 300_000
        '24', // от 1_000_000 130%
    ],
};

/**
 * core/models/common/OfferSliderSlides/ForIndividuals/CreditSlidesModel.js
 * core/models/pages/for-individuals/crediting/PotrebGoalsModel.js
 */
export const potrebGoalsCredit = {
    rate: '23,75',
    maxRate: '24,75',
};

/**
 * core/models/common/OfferSliderSlides/ForIndividuals/CreditSlidesModel.js
 * core/models/pages/for-individuals/CarsLoansModel.js
 */
export const carLoan = {
    rate: [
        '24,25',
        '24,75',
    ],
};

/**
 * core/models/pages/for-individuals/SelfEmployedLoanModel.js
 * core/models/common/MainSliderSlides/Individuals/IndividualsSlidesModel.js
 * core/models/common/OfferSliderSlides/ForIndividuals/CreditSlidesModel.js
 */
export const selfEmployedLoan = {
    rate: '24,5',
    maxRate: '24,75',
};

/**
 * core/models/pages/for-individuals/crediting/CreditMarketplaceModel.js
 * core/models/common/OfferSliderSlides/ForIndividuals/CreditSlidesModel.js
 */
export const marketCredit = {
    rate: '13',
};

/**
 * core/models/common/OfferSliderSlides/BusinessSlidesModel.js
 */
export const onlineCredit = {
    rate: '12,5',
};

/**
 * core/models/common/OfferSliderSlides/BusinessSlidesModel.js
 */
export const businessItCredit = {
    rate: '6,0',
};

/**
 * core/models/common/OfferSliderSlides/BusinessSlidesModel.js
 */

export const businessGreenMortgage = {
    rate: '14',
};

/**
 * components/Pages/ForIndividuals/TeacherCard/TeacherCardAdvantages.vue
 * core/models/pages/for-individuals/mortgage/MortgageRefinancing.js
 * core/models/common/OfferSliderSlides/ForIndividuals/MortgageSlidesModel.js
 * core/plugins/getMetaParamsForPage.js
 */
export const mortgageAndRefin = {
    rate: '22,75',
    maxRate: '23',
    ratesOnAmount: [
        '23',
    ],
};

/**
 * core/models/pages/for-individuals/mortgage/MortgageRefinancing.js
 */
export const mortgageAndRefinOtherBanks = {
    rate: '22,75',
    ratesOnAmount: [
        '22,75',
        '23',
    ],
};

export const mortgageBankProgramm = {
    rate: '22',
    maxRate: '23',
    ratesOnAmount: [
        '22',
        '23',
    ],
};

/**
 * core/models/pages/for-individuals/mortgage/MortgageChildrenModel.js
 * core/models/common/OfferSliderSlides/ForIndividuals/MortgageSlidesModel.js
 */
export const mortgageChild = {
    rate: '5,9',
    maxRate: '5,95',
};

/**
 * core/models/common/OfferSliderSlides/ForIndividuals/MortgageSlidesModel.js
 * core/models/pages/for-individuals/mortgage/MortgageBuildingModel.js
 */
export const mortgageConstruction = {
    rate: '22',
    maxRate: '23',
    ratesOnAmount: [
        '22',
        '23',
    ],
};

/**
 * core/models/pages/for-individuals/mortgage/MortgageBuildingModel.js
 */
export const mortgageConstructionOtherBanks = {
    rate: '20,75',
    ratesOnAmount: [
        '22,75',
        '23',
    ],
};

/**
 * core/models/common/MainSliderSlides/Individuals/IndividualsSlidesModel.js
 * core/models/common/OfferSliderSlides/ForIndividuals/MortgageSlidesModel.js
 * core/models/pages/for-individuals/mortgage/CommercialPropertyModel.js
 * core/plugins/getMetaParamsForPage.js
 */
export const mortgageCommercial = {
    rate: '23,5',
};

/**
 * core/models/common/OfferSliderSlides/BusinessSlidesModel.js
 */
export const mortgageCommercialBusiness = {
    rate: '14,5',
};

/**
 * core/models/common/OfferSliderSlides/BusinessSlidesModel.js
 * core/models/common/MainSliderSlides/Buisness/BuisnessSlidesModel.js
 * core/models/pages/business-page/SelfemployedModel.js
 * core/plugins/getMetaParamsForPage.js
 */
export const selfemloyedBusiness = {
    rate: '25,5',
};

/**
 * core/models/common/OfferSliderSlides/ForIndividuals/MortgageSlidesModel.js
 * core/models/pages/for-individuals/mortgage/VillagePropertyModel.js
 * core/plugins/getMetaParamsForPage.js
 */
export const mortgageVillage = {
    rate: '3',
};

/**
 * core/models/common/OfferSliderSlides/ForIndividuals/MortgageSlidesModel.js
 * core/models/pages/for-individuals/mortgage/ITMortgageModel.js
 * core/plugins/getMetaParamsForPage.js
 */
export const itMortgage = {
    rate: '6',
};

/**
 * core/models/pages/for-individuals/mortgage/GreenMortgageModel.js
 * core/models/common/OfferSliderSlides/ForIndividuals/MortgageSlidesModel.js
 */
export const greenMortgage = {
    rate: '22,5',
    ratesOnAmount: [
        '22,5',
    ],
};

/**
 * core/models/common/MainSliderSlides/Individuals/IndividualsSlidesModel.js
 * core/models/common/OfferSliderSlides/ForIndividuals/MortgageSlidesModel.js
 * core/models/pages/for-individuals/mortgage/ITMortgageBankModel.js
 * core/plugins/getMetaParamsForPage.js
 */
export const itMortgageBank = {
    rate: '18,75',
};

/**
 * core/models/common/MainSliderSlides/Individuals/IndividualsSlidesModel.js
 */
export const mortgageTwoPercent = {
    rate: '2',
};

/**
 * core/models/pages/for-individuals/mortgage/MortgageExcellentStudent.js
 */
export const mortgageExcellentStudent = {
    rate: '18,75',
};

/**
 * core/models/pages/for-individuals/mortgage/LargeFamilyMortgageModel.js
 */
export const largeFamilyMortgage = {
    rate: '22',
    maxRate: '22,5',
    ratesOnAmount: [
        '22',
        '22,5',
        '22',
    ],
};

/**
 * core/models/pages/for-individuals/crediting/CarLoanModel.js
 */
export const carLoanPotreb = {
    rate: '25',
};

/**
 * core/models/pages/for-individuals/mortgage/MortgageComboModel.js
 */
export const mortgageCombo = {
    rate: '5,9',
};
